import { useTranslation } from 'next-i18next'
import { useEffect, useMemo, useState } from 'react'
import useLoadEnums from '../../../services/enums'
import PluginClearFilter from './PluginClearFilter'

export default function PluginsFilterCategory ({ onCheckedCategoryChange, data, checkedCategories, plugins }) {
  const { t } = useTranslation(['plugins', 'categories'])
  const [showOnPageLoad, setShowOnPageLoad] = useState(false)
  const categories = useMemo(() => data?.categories || [], [data])
  const [shouldViewMore, setShouldViewMore] = useState(false)
  const { sortAsc } = useLoadEnums(categories, 'categories')
  const categoryInputs = sortAsc
    .filter(({ name }) => plugins.meta?.facets?.categories?.buckets?.find(bucket => bucket.key === name)?.doc_count)
    .map(({ id, name, translatedName }) => (
      <div
        className="form-check mt-2"
        key={id}
      >
        <input
          className="form-check-input"
          type="checkbox"
          value={name}
          id={`category${id}`}
          checked={!!checkedCategories.find(category => category === name)}
          onChange={(e) => handleCheckedCategoryChange(e.target.checked, name)}
        />
        <label
          className="form-check-label"
          htmlFor={`category${id}`}
        >
          {translatedName}
        </label>
        {
          !checkedCategories.find(category => category === name) && (
            <span className="badge rounded-pill text-bg-primary badge-sm ms-3">
              {
                plugins.meta?.facets?.categories?.buckets?.find(bucket => bucket.key === name)?.doc_count
              }
            </span>
          )
        }
      </div>
    ))
  const visibleCategoryInputs = useMemo(() => shouldViewMore ? categoryInputs : categoryInputs.slice(0, 7))

  useEffect(() => {
    if (window.innerWidth >= 992) {
      setShowOnPageLoad(true)
    }
  }, [])

  const handleCheckedCategoryChange = (isSelected, id) => {
    if (!isSelected) {
      onCheckedCategoryChange(checkedCategories.filter(categoryId => categoryId !== id))

      return
    }

    onCheckedCategoryChange([...checkedCategories, id])
  }

  return (
    <div>
      <button
        className="text-dark col-auto filter-bar__heading w-100 btn d-flex align-items-center justify-content-between fw-bold px-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseCategories"
        aria-expanded="false"
        aria-controls="collapseCategories"
      >
        <span>
          {t('browse_all.filter.category', { ns: 'plugins' })}
          {checkedCategories.length > 0 && (
            <span className="fw-normal ms-2 badge text-bg-primary px-2 py-1 rounded-pill">
              {checkedCategories.length}
            </span>
          )}
        </span>
        <svg
          viewBox="0 0 10 10"
          xmlns="http://www.w3.org/2000/svg"
          height="14"
          width="14"
        >
          <path
            d="M.5,2.75,4.646,7.1a.5.5,0,0,0,.708,0L9.5,2.75"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </button>
      <div
        className={`${showOnPageLoad ? 'show' : ''} collapse`}
        id="collapseCategories"
      >
        {visibleCategoryInputs}
        {visibleCategoryInputs.length >= 7 &&
          <div className="col-auto p-0">
            {!shouldViewMore && (
              <button
                className="btn btn-link text-start ps-0"
                onClick={() => setShouldViewMore(true)}
              >
                {t('view_more')}
              </button>
            )}
            {shouldViewMore && (
              <button
                className="btn btn-link text-start ps-0"
                onClick={() => setShouldViewMore(false)}
              >
                {t('view_less')}
              </button>
            )}
          </div>
        }
        {checkedCategories.length > 0 && (<PluginClearFilter callback={() => onCheckedCategoryChange([])} />)}
      </div>
    </div>
  )
}
